export default "__VITE_ASSET__C_8vPGyC__"